import {
  CCol,
  CForm,
  CFormFeedback,
  CFormInput,
  CFormSwitch,
  CInputGroup,
  CInputGroupText,
  CLoadingButton,
} from '@coreui/react-pro'
import React from 'react'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { useState } from 'react'
import ToastComponent from 'src/components/common/TaostComponent'
import PlayerService from 'src/service/PlayerService'
import { useEffect } from 'react'
import GeneralService from 'src/service/GeneralService'
import Bootbox from 'bootbox-react'

const PlayerStructure = (props) => {
  const [showPosBased, setShowPosBased] = useState(false)
  const [showPosConfirm, setShowPosConfirm] = useState(false)
  const [modalText, setModalText] = useState('')
  const [labelText, setLabelText] = useState('')
  const handlePosConfirm = () => {
    savePosFree()
    return setShowPosConfirm(false)
  }
  const handlePosCancel = () => {
    return setShowPosConfirm(false)
  }
  const handleChangeStatus = (event) => {
    if (event.target.checked === true) {
      setModalText('Are you sure you want to set Position Free Selection Mode for the game?')
    } else {
      setModalText('Are you sure you want to set Position Based Selection Mode for the game?')
    }
    setShowPosConfirm(true)
    setShowPosBased(event.target.checked)
  }

  const savePosFree = () => {
    const data = {}
    data.addOnType = 'team_view'
    data.status = showPosBased ? true : false
    GeneralService.changeUserGameAddOnStatus(data).then((res) => {
      if (res.status === 200) {
        ToastComponent(res.message, 'success')
      }
    })
  }

  useEffect(() => {
    PlayerService.getPlayerStructureInfo()
      .then((res) => {
        if (res.status === 200) {
          props.setPlayerStructureDetails(res.data)
        }
      })
      .then(() => {
        GeneralService.getUserGameInfo().then((res) => {
          if (res.status === 200) {
            const isTeamView = res.data?.team_view === 1
            setShowPosBased(isTeamView)
            setLabelText(
              isTeamView
                ? 'Switch to Position Based Selection Mode'
                : 'Switch to Position Free Selection Mode',
            )
            setModalText(
              isTeamView
                ? 'Are you sure you want to set Position Free Selection Mode for the game?'
                : 'Are you sure you want to set Position Based Selection Mode for the game?',
            )
          }
        })
      })
  }, [])
  const [loader, setLoader] = useState(false)
  const validationSchema = Yup.object().shape({
    min_gk: Yup.number()
      .min(1, 'Minimum value of 1 is required')
      .required('Min Batsman is required'),
    max_gk: Yup.number()
      .max(5, 'Maximum cannot be greater than 5')
      .required('Max Batsman is required'),

    min_def: Yup.number()
      .min(1, 'Minimum value of 1 is required')
      .required('Min Bowler is required'),
    max_def: Yup.number()
      .max(5, 'Maximum cannot be greater than 5')
      .required('Max Bowler is required'),
    min_mid: Yup.number()
      .min(1, 'Minimum value of 1 is required')
      .required('Min All-Rounder is required'),
    max_mid: Yup.number()
      .max(5, 'Maximum cannot be greater than 5')
      .required('Max All-Rounder is required'),
    min_fwd: Yup.number()
      .min(1, 'Minimum value of 1 is required')
      .required('Min Wicket Keeper is required'),
    max_fwd: Yup.number()
      .max(5, 'Maximum cannot be greater than 5')
      .required('Max Wicket Keeper is required'),
  })
  const formik = useFormik({
    initialValues: {
      min_gk: props.playerStructuredetails?.min_gk,
      max_gk: props.playerStructuredetails?.max_gk,
      min_def: props.playerStructuredetails?.min_def,
      max_def: props.playerStructuredetails?.max_def,
      min_mid: props.playerStructuredetails?.min_mid,
      max_mid: props.playerStructuredetails?.max_mid,
      min_fwd: props.playerStructuredetails?.min_fwd,
      max_fwd: props.playerStructuredetails?.max_fwd,
    },
    enableReinitialize: true,
    validationSchema,
    onSubmit: (data) => {
      setLoader(true)
      PlayerService.savePlayerStructure(data)
        .then((res) => {
          if (res.status === 200) {
            ToastComponent(res.message, 'success')
            setLoader(false)
          }
        })
        .then(() => {
          data.addOnType = 'team_view'
          data.status = showPosBased
          GeneralService.changeUserGameAddOnStatus(data)
        })
    },
  })

  return (
    <>
      <CCol xs={12}>
        <CForm className="row g-3" onSubmit={formik.handleSubmit}>
          <strong>
            <CFormSwitch
              size="lg"
              label={labelText}
              id="formSwitchCheckDefaultLg"
              checked={showPosBased ? true : false}
              onChange={handleChangeStatus}
              disabled={props.isTeamExists}
            />
          </strong>
          {!showPosBased && (
            <>
              <h6>Mode: Position Based Selection (Default)</h6>
              <CCol xs={12}>
                <ul>
                  <li>
                    In this mode, your game requires members to pick players based on the set player
                    limits for each position.
                  </li>
                  <li>You can set your own player selection limits for each position here.</li>
                  <li>
                    If no change is required, you can leave the default limits as currently set
                    below.
                  </li>
                </ul>
              </CCol>
            </>
          )}
          {showPosBased == 1 && (
            <>
              <h6>Mode: Position Free Selection Mode</h6>
              <CCol xs={12}>
                <ul>
                  <li>
                    In this mode, your game does not require members to pick players based on the
                    set player limits for each position.
                  </li>
                  <li>
                    There is no requirement for you to set player selection limits for each
                    position.
                  </li>
                  <li>
                    Members can select unlimited players from a certain position to pick their
                    fantasy team.
                  </li>
                  <li>This mode makes your game independent of position based restrictions.</li>
                </ul>
              </CCol>
            </>
          )}

          {!showPosBased && (
            <>
              <CInputGroup className="mb-3 fw-bold">
                <CInputGroupText className="fw-bold w-23" style={{ width: '170px' }}>
                  Min GK
                </CInputGroupText>
                <CFormInput
                  placeholder="Min GK"
                  disabled={props.isTeamExists}
                  className={
                    'form-control' +
                    (formik.errors.min_gk && formik.touched.min_gk ? ' is-invalid' : '')
                  }
                  defaultValue={formik.values.min_gk}
                  onChange={formik.handleChange}
                  aria-label="min_gk"
                  id="min_gk"
                />

                <CInputGroupText className="fw-bold">-</CInputGroupText>
                <CFormInput
                  placeholder="Max GK"
                  disabled={props.isTeamExists}
                  className={
                    'form-control' +
                    (formik.errors.max_gk && formik.touched.max_gk ? ' is-invalid' : '')
                  }
                  defaultValue={formik.values.max_gk}
                  onChange={formik.handleChange}
                  aria-label="max_gk"
                  id="max_gk"
                />
                <CInputGroupText className="fw-bold" style={{ width: '170px' }}>
                  Max GK
                </CInputGroupText>
                {formik.errors.max_gk && formik.touched.max_gk && (
                  <CFormFeedback invalid>{formik.errors.max_gk}</CFormFeedback>
                )}
                {formik.errors.max_gk && formik.touched.max_gk && (
                  <CFormFeedback invalid className="d-inline-block">
                    {formik.errors.max_gk}
                  </CFormFeedback>
                )}
              </CInputGroup>

              <CInputGroup className="mb-3 fw-bold">
                <CInputGroupText className="fw-bold" style={{ width: '170px' }}>
                  Min DEF
                </CInputGroupText>
                <CFormInput
                  placeholder="Min DEF"
                  disabled={props.isTeamExists}
                  className={
                    'form-control' +
                    (formik.errors.min_def && formik.touched.min_def ? ' is-invalid' : '')
                  }
                  defaultValue={formik.values.min_def}
                  onChange={formik.handleChange}
                  aria-label="min_def"
                  id="min_def"
                />

                <CInputGroupText className="fw-bold">-</CInputGroupText>
                <CFormInput
                  placeholder="Max DEF"
                  disabled={props.isTeamExists}
                  className={
                    'form-control' +
                    (formik.errors.max_def && formik.touched.max_def ? ' is-invalid' : '')
                  }
                  defaultValue={formik.values.max_def}
                  onChange={formik.handleChange}
                  aria-label="max_def"
                  id="max_def"
                />

                <CInputGroupText className="fw-bold" style={{ width: '170px' }}>
                  Max DEF
                </CInputGroupText>
                {formik.errors.min_def && formik.touched.min_def && (
                  <CFormFeedback invalid>{formik.errors.min_def}</CFormFeedback>
                )}
                {formik.errors.max_def && formik.touched.max_def && (
                  <CFormFeedback invalid>{formik.errors.max_def}</CFormFeedback>
                )}
              </CInputGroup>

              <CInputGroup className="mb-3 fw-bold">
                <CInputGroupText className="fw-bold w-22" style={{ width: '170px' }}>
                  Min MID
                </CInputGroupText>
                <CFormInput
                  placeholder="Min MID"
                  disabled={props.isTeamExists}
                  className={
                    'form-control' +
                    (formik.errors.min_mid && formik.touched.min_mid ? ' is-invalid' : '')
                  }
                  defaultValue={formik.values.min_mid}
                  onChange={formik.handleChange}
                  aria-label="min_mid"
                  id="min_mid"
                />

                <CInputGroupText className="fw-bold">-</CInputGroupText>
                <CFormInput
                  placeholder="Max MID"
                  disabled={props.isTeamExists}
                  className={
                    'form-control' +
                    (formik.errors.max_mid && formik.touched.max_mid ? ' is-invalid' : '')
                  }
                  defaultValue={formik.values.max_mid}
                  onChange={formik.handleChange}
                  aria-label="max_mid"
                  id="max_mid"
                />

                <CInputGroupText className="fw-bold" style={{ width: '170px' }}>
                  Max MID
                </CInputGroupText>
                {formik.errors.min_mid && formik.touched.min_mid && (
                  <CFormFeedback invalid>{formik.errors.min_mid}</CFormFeedback>
                )}
                {formik.errors.max_mid && formik.touched.max_mid && (
                  <CFormFeedback invalid>{formik.errors.max_mid}</CFormFeedback>
                )}
              </CInputGroup>

              <CInputGroup className="mb-3 fw-bold">
                <CInputGroupText className="fw-bold" style={{ width: '170px' }}>
                  Min FWD
                </CInputGroupText>
                <CFormInput
                  placeholder="Min FWD"
                  disabled={props.isTeamExists}
                  className={
                    'form-control' +
                    (formik.errors.min_fwd && formik.touched.min_fwd ? ' is-invalid' : '')
                  }
                  defaultValue={formik.values.min_fwd}
                  onChange={formik.handleChange}
                  aria-label="min_fwd"
                  id="min_fwd"
                />

                <CInputGroupText className="fw-bold">-</CInputGroupText>
                <CFormInput
                  placeholder="Max FWD"
                  disabled={props.isTeamExists}
                  className={
                    'form-control' +
                    (formik.errors.max_fwd && formik.touched.max_fwd ? ' is-invalid' : '')
                  }
                  defaultValue={formik.values.max_fwd}
                  onChange={formik.handleChange}
                  aria-label="max_fwd"
                  id="max_fwd"
                />

                <CInputGroupText className="fw-bold" style={{ width: '170px' }}>
                  Max FWD
                </CInputGroupText>
                {formik.errors.min_fwd && formik.touched.min_fwd && (
                  <CFormFeedback invalid>{formik.errors.min_fwd}</CFormFeedback>
                )}
                {formik.errors.max_fwd && formik.touched.max_fwd && (
                  <CFormFeedback invalid>{formik.errors.max_fwd}</CFormFeedback>
                )}
              </CInputGroup>
              <CCol md={6}>
                <CLoadingButton
                  type="submit"
                  color="success"
                  variant="outline"
                  loading={loader}
                  disabled={props.isTeamExists}
                  id="submit"
                >
                  Submit
                </CLoadingButton>
              </CCol>
            </>
          )}
        </CForm>
      </CCol>
      <Bootbox
        show={showPosConfirm}
        type={'confirm'}
        message={modalText}
        onSuccess={handlePosConfirm}
        onCancel={handlePosCancel}
        onClose={handlePosCancel}
      />
    </>
  )
}

export default PlayerStructure
